import styles from './action.less?modules';
import { useTrigger } from '@/utils/comHook.js';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import { useContext } from 'react';
import { FunctionContext } from '../../index';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useDispatch } from 'dva';

const Action = (props) => {
  const trigger = useTrigger();
  const trigger2 = useTrigger();
  const dispatch = useDispatch();
  const { id } = props;
  const { fetchData } = useContext(FunctionContext);
  const handleCancel = () => {
    trigger2.close();
    message.info('已取消通过');
  };
  const handleCancel2 = () => {
    trigger2.close();
    message.info('已取消拒绝');
  };
  const pass = () => {
    dispatch({
      type: 'dr/pass',
      payload: {
        id,
      },
      callback: (res) => {
        console.log(res);
        if (res.code === 1) {
          message.error(res.message);
        }
        fetchData();
        trigger.close();
      },
    });
  };
  const reject = () => {
    dispatch({
      type: 'dr/reject',
      payload: {
        id,
      },
      callback: () => {
        fetchData();
        trigger2.close();
        message.success('拒绝成功!');
      },
    });
  };
  return (
    <div className={styles.handle_btn}>
      <ModalConfirmML
        title="是否通过?"
        handleOk={pass}
        handleCancel={handleCancel}
        visible={trigger.visible}
        value="通过"
        icon={<ExclamationCircleOutlined />}
      />
      <ModalConfirmML
        title="是否拒绝?"
        handleOk={reject}
        handleCancel={handleCancel2}
        visible={trigger2.visible}
        value="拒绝"
        icon={<ExclamationCircleOutlined />}
      />
    </div>
  );
};
export default Action;
